import { render, staticRenderFns } from "./DownloadingTip.vue?vue&type=template&id=53b8dce5&scoped=true&"
var script = {}
import style0 from "./DownloadingTip.vue?vue&type=style&index=0&id=53b8dce5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b8dce5",
  null
  
)

export default component.exports